"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHumidityChartData = void 0;
const react_1 = require("react");
const humidityDataUtils_1 = require("../../utils/humidity/humidityDataUtils");
const useLeakDetectorData_1 = require("../leakdetector/useLeakDetectorData");
const useHumidityChartData = ({ sensorId, hubId, days = 7, enabled = true, }) => {
    const { data: leakDetectorRollupData, loading: leakDetectorLoading, error: leakDetectorError, } = (0, useLeakDetectorData_1.useLeakDetectorData)({
        sensorId,
        days,
        enabled,
    });
    const humidityData = (0, react_1.useMemo)(() => (0, humidityDataUtils_1.formatHumidityChartData)(leakDetectorRollupData), [leakDetectorRollupData]);
    const latestHumidityValueFromEvent = (0, humidityDataUtils_1.useLatestHumidityFromEvents)(hubId, sensorId);
    const latestHumidityValue = (0, react_1.useMemo)(() => (0, humidityDataUtils_1.calculateLatestHumidityValue)(humidityData, latestHumidityValueFromEvent), [humidityData, latestHumidityValueFromEvent]);
    // Update the last chart data point if it's a gap and we have a latest value
    const updatedHumidityData = (0, react_1.useMemo)(() => {
        if (!humidityData || humidityData.length < 7 || latestHumidityValue === null) {
            return humidityData;
        }
        const lastIndex = humidityData.length - 1;
        const lastDataPoint = humidityData[lastIndex];
        if (lastDataPoint.value === null) {
            const updatedData = [...humidityData];
            updatedData[lastIndex] = {
                ...lastDataPoint,
                value: latestHumidityValue,
            };
            return updatedData;
        }
        return humidityData;
    }, [leakDetectorRollupData]);
    return {
        data: updatedHumidityData,
        latestValue: latestHumidityValue,
        loading: leakDetectorLoading,
        error: leakDetectorError,
        rawLeakDetectorData: leakDetectorRollupData,
    };
};
exports.useHumidityChartData = useHumidityChartData;
